@if (displayTitle) {
  <i-title level="2" text="Lien(s)"></i-title>
}
<section [formGroup]="formCourrierLink" [ngClass]="{ 'mt-4': displayTitle }">
  <div class="row">
    <div class="col-md-5 p-fluid">
      <h4 class="custom-h4-title">{{ 'courrierFiche.linkMail' | translate }}</h4>
      <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="formCourrierLink.get('linkCourrierId')" styleClass="d-block w-100">
      </i-input>
    </div>
    <div class="col-md-3">
      <h4 class="custom-h4-title">{{ 'courrierFiche.relationType' | translate }}</h4>
      <p-dropdown
        [options]="typesLV"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        [placeholder]="'courrierFiche.chooseRelation' | translate"
        formControlName="typeLiaison"
        [filter]="true"
        [emptyFilterMessage]="'courrierFiche.noResultsFound' | translate"
        [showClear]="true">
        <!-- Weirdly enough, the color is not applied to the selected item, it takes the selectedItem as a placeholder. I don't get why so on the 03/09/25 i had to force our color, sorry 🦊-->
        <ng-template let-item pTemplate="selectedItem"
          ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
        >
      </p-dropdown>
    </div>
    <div class="col-md-4 d-flex align-items-end justify-content-end">
      <i-button
        [text]="'courrierFiche.addLink' | translate"
        styleClass="green"
        (click)="submitLink()"
        [disabled]="!formCourrierLink.valid"
        icon="bi bi-plus-circle-fill me-3"
        iconPos="left">
      </i-button>
    </div>
  </div>
</section>
@if (hasDelibeAsATenant) {
  <section [formGroup]="formDelibeLink" class="mt-2">
    <div class="row">
      <div class="col-md-5 p-fluid">
        <h4 class="custom-h4-title">{{ 'courrierFiche.linkDelibe' | translate }}</h4>
        <i-input [type]="'number'" [iInput]="{ placeholder: '' }" [control]="formDelibeLink.get('linkDelibeId')" styleClass="d-block w-100">
        </i-input>
      </div>
      <div class="col-md-3">
        <h4 class="custom-h4-title">{{ 'courrierFiche.relationType' | translate }}</h4>
        <p>{{ 'courrierFiche.deliberation' | translate }}</p>
      </div>
      <div class="col-md-4 d-flex align-items-end justify-content-end">
        <i-button
          [text]="'courrierFiche.addLink' | translate"
          styleClass="green"
          (click)="submitLinkDelibe()"
          [disabled]="!formDelibeLink.valid"
          icon="bi bi-plus-circle-fill me-3"
          iconPos="left">
        </i-button>
      </div>
    </div>
  </section>
}

<hr class="my-3" />

<div class="mt-1 mb-3">
  <div class="row">
    <div class="col-12">
      @if (links?.length > 0) {
        <h4 class="custom-h4-title underlined"><img src="assets/img/iapps/icourrier.png" class="img--medium me-2" /> iCourrier</h4>
        <p-table
          [value]="links"
          [columns]="columns"
          [responsive]="true"
          class="super-compos-table w-100"
          dataKey="id"
          selectionMode="single"
          scrollHeight="40vh">
          <ng-template pTemplate="header" let-columns let-item>
            <tr>
              @for (col of columns; track col; let i = $index) {
                <th [id]="col.field" class="tac-header-line">
                  <h4 class="custom-h4-title tac-col-header">{{ col.header }}</h4>
                </th>
              }
              <th id="tac-header-line-courrier-lien" class="tac-header-line"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-columns="columns" let-item let-expanded="expanded">
            <tr [pSelectableRow]="item">
              @for (col of columns; track col; let last = $last) {
                <td
                  (click)="onRowSelect(item)"
                  [pTooltip]="'courrierFiche.openLinkedMail' | translate: { id: item?.idFormatted }"
                  tooltipPosition="top">
                  <span [ngClass]="{ 'idContainerForTable ': col.field === 'idFormatted' }">{{ item[col.field] }}</span>
                </td>
              }
              <td>
                <div class="d-flex justify-content-center align-items-center link" (click)="removeLink(item)">
                  <i [pTooltip]="'courrierFiche.removeLink' | translate" tooltipPosition="bottom" class="bi bi-trash3 iconSmall trashColor"></i>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
      @if (linksDelibe?.length > 0) {
        <h4 class="custom-h4-title underlined" [ngClass]="{ 'mt-3': links?.length }">
          <img src="assets/img/iapps/idelibe.png" class="img--medium me-2" /> iDélibé
        </h4>
        <p-table
          [value]="linksDelibe"
          [columns]="columnsDelibe"
          [responsive]="true"
          class="super-compos-table w-100"
          dataKey="delibeLinkId"
          selectionMode="single">
          <ng-template pTemplate="header" let-columns let-item>
            <tr>
              @for (col of columns; track col; let i = $index) {
                <th [id]="col.field" class="tac-header-line">
                  <h4 class="custom-h4-title tac-col-header">{{ col.header }}</h4>
                </th>
              }
              <th id="tac-header-line-courrier-lien2" class="tac-header-line"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-columns="columns" let-item let-expanded="expanded">
            <tr [pSelectableRow]="item">
              @for (col of columns; track col; let last = $last) {
                <td (click)="onRowSelectiDelibePoint(item)">
                  <span [ngClass]="{ 'idContainerForTable ': col.field === 'idFormatted' }">{{ item[col.field] }}</span>
                </td>
              }
              <td>
                <div class="d-flex justify-content-center align-items-center link" (click)="removeLinkDelibe(item)">
                  <i [pTooltip]="'courrierFiche.removeLink' | translate" tooltipPosition="bottom" class="bi bi-trash3 iconSmall trashColor"></i>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
      @if (links?.length === 0 && linksDelibe?.length === 0) {
        <div class="alert alert-info">{{ 'courrierFiche.noLinksForThisMail' | translate }}</div>
      }
    </div>
  </div>
</div>
